import React from "react"

const ContentVisibility = ({ children, hidden }): JSX.Element => (hidden ? null : <>{children}</>)

export default ContentVisibility
